import Amplify, { Auth } from "aws-amplify";
import awsExports from "./aws-exports";
import awsCognitoSettings from "./aws-external-cognito";

Amplify.configure(awsExports);
Amplify.configure(awsCognitoSettings);

// (nvogler) Temporary code to resolve first 'autologin' for a user
// previously users were never logged out, creating issues from having multiple keys stored
/**
 * Look for the one key that starts with "LastAuthUser.",
 * and return its value (the last‐signed-in username).
 */
function getLastAuthUser() {
  const lastKey = Object.keys(window.localStorage).find((k) =>
    k.startsWith("LastAuthUser.")
  );
  return lastKey ? window.localStorage.getItem(lastKey) : null;
}

/**
 * Remove every CognitoIdentityServiceProvider.* entry
 * whose username segment ≠ the last auth user,
 * and also any LastAuthUser.* entries whose value ≠ last auth user.
 */
function pruneAmplifyStorage() {
  const lastUser = getLastAuthUser();
  if (!lastUser) {
    console.warn("No LastAuthUser.* key found; nothing pruned.");
    return;
  }

  console.log(`Last authenticated user: ${lastUser} → pruning others.`);

  Object.keys(window.localStorage).forEach((key) => {
    if (key.startsWith("CognitoIdentityServiceProvider.")) {
      const parts = key.split(".");
      const username = parts[2]; // <CLIENT_ID>.<USERNAME>.<tokenType>
      if (username && username !== lastUser) {
        window.localStorage.removeItem(key);
      }
    }

    if (
      key.startsWith("LastAuthUser.") &&
      window.localStorage.getItem(key) !== lastUser
    ) {
      window.localStorage.removeItem(key);
    }
  });
}

async function bootstrapAuth() {
  pruneAmplifyStorage();

  try {
    const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
    await Auth.currentSession();
    window.currentUser = user;
    window.autoLoginSucceeded = true;
    return user;
  } catch {
    window.autoLoginSucceeded = false;
    return;
  }
}
window.bootstrapAuth = bootstrapAuth;
window.autoLoginSucceeded = false;

async function signIn(username, password) {
  try {
    const user = await Auth.signIn(username, password);
    return user;
  } catch (error) {
    console.log("error signing in:", error);
    return;
  }
}
window.signInFunction = signIn;

async function signInCustomAuth(username, password) {
  try {
    const user = await Auth.signIn(username, password);
    theUser = user;

    // Checking for custom challenge of NEW_PASSWORD_REQUIRED
    // This happens when a client account was made for the client and they were given a temp password that needs to be reset
    if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
      return user.challengeName;
    }

    window.currentUser = user;
    return user;
  } catch (error) {
    if (error.name === "UserNotConfirmedException") {
      console.log("User has not confirmed account:", error);
      return "UNCONFIRMED";
    } else {
      console.log("error signing in with custom auth:", error);
    }
    return;
  }
}
window.signInCustomAuthFunction = signInCustomAuth;

async function signInCustomAuthConfirm(confirmationCode) {
  // if we already auto-logged in, skip the confirm step
  if (window.autoLoginSucceeded) {
    const user = window.currentUser;
    return user;
  }

  try {
    const user = await Auth.sendCustomChallengeAnswer(
      window.currentUser,
      confirmationCode
    );
    return user;
  } catch (error) {
    console.log("error signing in signInCustomAuthConfirm:", error);
    return;
  }
}
window.signInCustomAuthConfirmFunction = signInCustomAuthConfirm;

async function signUp(name, lastname, username, password, phone, isProvider) {
  try {
    const { user } = await Auth.signUp({
      username: username,
      password: password,
      attributes: {
        name: name,
        family_name: lastname,
        phone_number: phone,
        "custom:isprovider": isProvider,
      },
    });
    return user;
  } catch (error) {
    console.log("error signing up:", error);
    return;
  }
}
window.signUpFunction = signUp;

async function resendSignUpConfirm(username) {
  try {
    await Auth.resendSignUp(username);
    return "success";
  } catch (error) {
    console.log("error resending sign up confirm code", error);
  }
}
window.resendSignUpConfirmFunction = resendSignUpConfirm;

async function signUpConfirm(username, confirmationCode) {
  try {
    await Auth.confirmSignUp(username, confirmationCode);
    return "success";
  } catch (error) {
    console.log("error confirming sign up", error);
  }
}
window.signUpConfirmFunction = signUpConfirm;

async function forgotPassword(username) {
  try {
    await Auth.forgotPassword(username);
    return "success";
  } catch (error) {
    console.log("error forgot password request", error);
  }
}
window.forgotPasswordFunction = forgotPassword;

async function forgotPasswordSubmit(username, emailCode, password) {
  try {
    await Auth.forgotPasswordSubmit(username, emailCode, password);
    return "success";
  } catch (error) {
    console.log("error forgot password action", error);
  }
}
window.forgotPasswordSubmitFunction = forgotPasswordSubmit;

async function resetTempPassword(username, password) {
  try {
    await Auth.completeNewPassword(theUser, password);
    return "success";
  } catch (error) {
    console.log("error resetting temp password", error);
  }
}
window.resetTempPasswordFunction = resetTempPassword;

async function signOut() {
  try {
    // this will clear Amplify’s access, id and refresh tokens
    // to prevent auth loops
    await Auth.signOut({ global: true });
  } catch (err) {
    console.log("error signing out:", err);
  }
  // clear state
  window.currentUser = null;
  window.autoLoginSucceeded = false;
  theUser = null;
}
window.signOutFunction = signOut;

var theUser;
